import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, uaeProjectsBaseURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_AIRPORTS_BASED_ON_CONFIG_ID, GET_AIRPORTS_BASED_ON_CONFIG_ID_ERROR, GET_AIRPORTS_BASED_ON_CONFIG_ID_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getAirportsBasedOnConfig({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/v1/airports`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
        Authorization: Constant?.CLIENT_TOKEN,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_AIRPORTS_BASED_ON_CONFIG_ID_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_AIRPORTS_BASED_ON_CONFIG_ID_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_AIRPORTS_BASED_ON_CONFIG_ID_ERROR, payload: error });
  }
}

export function* watchGetAirportsBasedOnConfigId() {
  yield takeEvery(GET_AIRPORTS_BASED_ON_CONFIG_ID, getAirportsBasedOnConfig);
}

function* getAirportsBasedOnConfigSaga() {
  yield all([fork(watchGetAirportsBasedOnConfigId)]);
}

export default getAirportsBasedOnConfigSaga;
